import styled, { css } from 'styled-components';

import { DEVICE } from '@hero/constants';

const PageLayout = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  height: calc(100vh - 275px);

  ${({ fullHeight }) =>
    fullHeight &&
    css`
      height: calc(100vh - 40px);
    `}

  ${DEVICE.mobile.max} {
    height: 100%;
  }
`;

const PageLayoutContentInner = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  gap: 24px;
  padding: 0 var(--size-page-padding-xxl);

  ${DEVICE.mobile.max} {
    padding: 0 var(--size-page-padding-sm);
  }
`;

const PageLayoutContent = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  height: 100%;
  overflow-y: overlay;
  padding-top: 16px;

  ${DEVICE.mobile.max} {
    overflow-y: unset;
  }
`;

const LoadingBar = styled.div`
  background-color: ${({ isLoading }) => (isLoading ? 'transparent' : 'var(--color-bg-body)')};
  height: 2px;
  overflow: hidden;
  position: relative;
  transition:
    height 0.3s ease-in-out,
    background-color 0.3s ease-in-out;
  width: 100%;

  &::after {
    background-color: ${({ isLoading }) =>
      isLoading ? 'var(--color-accent-primary-stronger)' : 'var(--color-bg-body)'};
    content: '';
    height: 100%;
    left: 0;
    position: absolute;
    top: 0;
    transition: ${({ isLoading }) =>
      isLoading ? 'none' : 'width 0.3s ease-in-out, background-color 0.3s ease-in-out'};
    width: ${({ isLoading }) => (isLoading ? '30%' : '100%')};
  }

  ${({ isLoading }) =>
    isLoading &&
    css`
      &::after {
        animation: loading-progress 2s linear infinite;
      }

      @keyframes loading-progress {
        0% {
          left: -30%;
          width: 30%;
        }
        100% {
          left: 100%;
          width: 30%;
        }
      }
    `}
`;

export { LoadingBar, PageLayout, PageLayoutContent, PageLayoutContentInner };
